var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDiagonalRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.7507 3C10.3365 3 10.0007 3.33579 10.0007 3.75C10.0007 4.16421 10.3365 4.5 10.7507 4.5H18.4198L3.22003 19.6998C2.92145 19.9983 2.92145 20.4824 3.22003 20.781C3.5186 21.0796 4.00269 21.0796 4.30126 20.781L19.5007 5.58158V13.25C19.5007 13.6642 19.8365 14 20.2507 14C20.6649 14 21.0007 13.6642 21.0007 13.25V3.75C21.0007 3.33579 20.6649 3 20.2507 3H10.7507Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDiagonalRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-diagonal-regular.972353eb.svg";
export { ForwardRef as ReactComponent };